































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { SurveyProducts } from '@/enum/Products';

interface SurveyQuestion {
  key: string;
  // Özel puan alanlarında kullanıcının yazdığı orijinal etiket (key slug olarak tutulur).
  key_label?: string | null;
  title: string | null;
  helper_text: string | null;
  max_score: number;
  low_score_threshold: number;
  score_hint?: string | null;
  reason_key: string;
  reason_required: boolean;
  reason_label: string;
  reason_placeholder: string;
}

interface SurveyExtraField {
  key: string;
  type: string;
  label: string;
  optional_label?: string;
  placeholder: string;
  required: boolean;
}

// 'general' ve 'beta-screen' yerleşik tipler; panelden serbestçe yeni tip (slug) eklenebilir.
type SurveyMode = string;

interface LinkedinFields {
  show_linkedin?: boolean;
  linkedin_title?: string;
  linkedin_url?: string;
  linkedin_label?: string;
}

interface SurveySetting {
  id?: number;
  mode: SurveyMode;
  product_id: number;
  product_name?: string | null;
  title: string;
  description: string | null;
  remind_later_text: string;
  submit_text: string;
  active: number;
  // 1: anket her takvim ayinin basinda kullaniciya yeniden gosterilir. 0: mevcut tek seferlik davranis.
  aylik_tekrar: number;
  // Ankette gosterilecek aylik tekrar duyurusu; bos/null ise backend varsayilan metni doner.
  aylik_tekrar_metni: string | null;
  sort_order: number;
  questions: SurveyQuestion[];
  // general modunda LinkedIn alanları extra_fields nesnesi içinde tutulur;
  // beta-screen modunda extra_fields dizi olduğu için LinkedIn ayrı `linkedin` nesnesinde tutulur.
  extra_fields: SurveyExtraField[] | Record<string, any>;
  linkedin?: LinkedinFields;
}

// Anket tipine göre varsayılan ürün (kullanıcı listeden değiştirebilir).
const DEFAULT_PRODUCT_ID: Record<SurveyMode, number> = {
  general: 7,
  'beta-screen': 8
};

// Yeni anket oluşturulurken gelen varsayılan LinkedIn alanları (kullanıcı düzenleyebilir).
const DEFAULT_LINKEDIN: LinkedinFields = {
  show_linkedin: true,
  linkedin_title: "Zirve Bilgisayar'ı <span class=\"blue--text text--darken-3\">LinkedIn</span>'de takip edin",
  linkedin_url: 'https://www.linkedin.com/company/zirve-bilgisayar',
  linkedin_label: 'Zirve Bilgisayar'
};

@Component({
  components: {}
})
export default class SurveySettings extends Vue {
  surveySettings: SurveySetting[] = [];
  surveySettingsLoading: boolean = false;
  savingSettingKey: string | null = null;
  surveySettingDialog: boolean = false;
  editingSurveySetting: SurveySetting | null = null;
  editingSurveySettingIndex: number = -1;

  defaultRemindLaterText: string = 'Daha Sonra Hatırlat';
  defaultSubmitText: string = 'Gönder';

  ratingFieldOptions = [
    { text: 'Memnuniyet Puanı', value: 'memnuniyet_puani' },
    { text: 'Tavsiye Puanı', value: 'tavsiye_puani' }
  ];

  reasonFieldOptions = [
    { text: 'Değerlendirme Sebebi', value: 'degerlendirme_sebebi' },
    { text: 'Tavsiye / Geliştirme Metni', value: 'tavsiye_metni' }
  ];

  baseSurveyModeOptions = [
    { text: 'Genel Memnuniyet Anketi', value: 'general' },
    { text: 'e-İcra Beta Ekran Değerlendirmesi', value: 'beta-screen' }
  ];

  // v-combobox (v-select'in aksine) value→text eşlemesi yapmadığından etiket metniyle çalışır:
  // liste = etiketler; slug'a çeviri editingSurveyModeText setter + onSurveyModeChange'te yapılır.
  get surveyModeOptionTexts(): string[] {
    const texts = this.baseSurveyModeOptions.map(option => option.text);
    const seen = new Set(texts.map(text => text.toLocaleLowerCase('tr')));
    const sources = this.editingSurveySetting
      ? [this.editingSurveySetting, ...this.surveySettings]
      : [...this.surveySettings];
    sources.forEach(setting => {
      if (!setting.mode || setting.mode === 'general' || setting.mode === 'beta-screen') return;
      const label = this.getSurveyModeLabel(setting);
      const key = label.toLocaleLowerCase('tr');
      if (!seen.has(key)) {
        seen.add(key);
        texts.push(label);
      }
    });
    return texts;
  }

  // Combobox'ın gösterdiği metin: yerleşik tiplerde tam liste etiketi, özel tiplerde mode_label.
  // Setter ham metni mode'a koyar; @change (onSurveyModeChange) slug'lar ve etiketi saklar.
  get editingSurveyModeText(): string {
    const setting = this.editingSurveySetting;
    // Kutu boşaltıldığında (mode '') eski mode_label'a düşme — boş kalmalı ki silme çalışsın.
    if (!setting || !setting.mode) return '';
    const base = this.baseSurveyModeOptions.find(option => option.value === setting.mode);
    if (base) return base.text;
    return this.getSurveyModeLabel(setting);
  }

  set editingSurveyModeText(raw: string) {
    if (!this.editingSurveySetting) return;
    this.editingSurveySetting.mode = String(raw == null ? '' : raw);
  }

  // ---- Puan Alanı: anket tipiyle aynı desen (etiket görünür, slug arkada) ----

  // Combobox listesi: yerleşik alanlar + tüm anketlerin sorularında kullanılmış özel alan etiketleri.
  get ratingFieldOptionTexts(): string[] {
    const texts = this.ratingFieldOptions.map(option => option.text);
    const seen = new Set(texts.map(text => text.toLocaleLowerCase('tr')));
    const sources = this.editingSurveySetting
      ? [this.editingSurveySetting, ...this.surveySettings]
      : [...this.surveySettings];
    sources.forEach(setting => {
      (setting.questions || []).forEach(question => {
        if (!question.key) return;
        if (this.ratingFieldOptions.some(option => option.value === question.key)) return;
        const label = question.key_label || question.key;
        const key = label.toLocaleLowerCase('tr');
        if (!seen.has(key)) {
          seen.add(key);
          texts.push(label);
        }
      });
    });
    return texts;
  }

  // Kutuda görünen metin: yerleşikte liste etiketi, özel alanda yazılan etiket (yoksa slug).
  getRatingKeyText(question: SurveyQuestion): string {
    if (!question.key) return '';
    const base = this.ratingFieldOptions.find(option => option.value === question.key);
    if (base) return base.text;
    return question.key_label || question.key;
  }

  // Yazılan metni yerleşik + kayıtlı özel alanlarla eşleştirir (value ya da etiket üzerinden).
  findRatingKeyOption(raw: string): { value: string; label: string | null } | undefined {
    const lower = raw.toLocaleLowerCase('tr');
    const base = this.ratingFieldOptions.find(
      option => option.value === raw || option.text.toLocaleLowerCase('tr') === lower
    );
    if (base) return { value: base.value, label: null };
    const sources = this.editingSurveySetting
      ? [this.editingSurveySetting, ...this.surveySettings]
      : [...this.surveySettings];
    for (const setting of sources) {
      for (const question of setting.questions || []) {
        if (!question.key) continue;
        const label = question.key_label || question.key;
        if (question.key === raw || label.toLocaleLowerCase('tr') === lower) {
          return { value: question.key, label: question.key_label || null };
        }
      }
    }
    return undefined;
  }

  onRatingKeyChange(question: SurveyQuestion, rawValue: string | null): void {
    const raw = String(rawValue == null ? '' : rawValue).trim();
    if (!raw) {
      // Kutu bilerek boşaltılmış olabilir; kaydette varsayılana düşer.
      question.key = '';
      return;
    }
    const matched = this.findRatingKeyOption(raw);
    if (matched) {
      question.key = matched.value;
      if (matched.label) this.$set(question, 'key_label', matched.label);
      return;
    }
    const slug = this.normalizeRatingKey(raw);
    if (!slug) {
      question.key = '';
      return;
    }
    question.key = slug;
    this.$set(question, 'key_label', raw);
  }

  surveySettingHeaders = [
    { text: 'ID', value: 'id', sortable: true, width: '80px' },
    { text: 'Anket Başlığı', value: 'title', sortable: true },
    { text: 'Tip', value: 'mode', sortable: true, width: '210px' },
    { text: 'Ürün', value: 'product', sortable: true, width: '160px' },
    { text: 'Aktif', value: 'active', sortable: true, align: 'center', width: '110px' },
    { text: 'Aylık Tekrar', value: 'aylik_tekrar', sortable: true, align: 'center', width: '150px' },
    { text: 'Sıra', value: 'sort_order', sortable: true, align: 'center', width: '90px' },
    { text: 'Soru', value: 'questions', sortable: false, align: 'center', width: '90px' },
    { text: 'İşlemler', value: 'actions', sortable: false, align: 'right', width: '120px' }
  ];

  get productOptions() {
    const options = Object.keys(SurveyProducts).map(id => ({
      text: SurveyProducts[Number(id)],
      value: Number(id)
    }));

    // Düzenlenen ankette seçili ürün listede yoksa, değer boş görünmesin diye ekle.
    const currentId = this.editingSurveySetting?.product_id;
    if (currentId != null && !options.some(option => option.value === currentId)) {
      const fallbackName = this.editingSurveySetting?.product_name || `Ürün #${currentId}`;
      options.unshift({ text: fallbackName, value: currentId });
    }

    return options;
  }

  getProductName(setting: SurveySetting): string {
    return SurveyProducts[setting.product_id] || setting.product_name || `Ürün #${setting.product_id}`;
  }

  // LinkedIn alanları her iki modda da düzenlenebilir. general modunda extra_fields nesnesi,
  // beta-screen modunda (extra_fields dizi olduğundan) ayrı `linkedin` nesnesi LinkedIn deposudur.
  // `linkedin` nesnesi beta-screen için create/normalize/onSurveyModeChange aşamalarında garanti edilir.
  get linkedinFields(): LinkedinFields {
    const setting = this.editingSurveySetting;
    if (!setting) return {};
    if (Array.isArray(setting.extra_fields)) {
      return (setting.linkedin || {}) as LinkedinFields;
    }
    return setting.extra_fields as LinkedinFields;
  }

  // Duyuru metni yalnizca aylik tekrar acikken anlamli; kapaliyken alan pasif gorunur.
  get editingAylikTekrarAktif(): boolean {
    return Number(this.editingSurveySetting?.aylik_tekrar) === 1;
  }

  getSettingKey(setting: SurveySetting): string {
    return setting.id ? `id-${setting.id}` : `new-${setting.mode}-${setting.product_id}`;
  }

  getSurveyModeLabel(setting: SurveySetting): string {
    if (setting.mode === 'beta-screen') return 'e-İcra Beta';
    if (setting.mode === 'general') return 'Genel';
    // Özel tipte kullanıcının yazdığı orijinal etiket extra_fields.mode_label'da saklanır.
    const extras = setting.extra_fields;
    const label = extras && !Array.isArray(extras) ? (extras as Record<string, any>).mode_label : null;
    return label || setting.mode;
  }

  // Serbest yazılan metni slug'a çevirir: küçük harf, Türkçe karakterler sadeleşir,
  // [a-z0-9-_] dışı karakterler ayraç olur, en fazla 30 karakter.
  normalizeSlug(raw: string, separator: '-' | '_'): string {
    const turkishMap: Record<string, string> = { ç: 'c', ğ: 'g', ı: 'i', i̇: 'i', ö: 'o', ş: 's', ü: 'u' };
    const sepPattern = new RegExp(`\\${separator}+`, 'g');
    const trimPattern = new RegExp(`^\\${separator}+|\\${separator}+$`, 'g');
    return raw
      .toLocaleLowerCase('tr')
      .replace(/[çğıi̇öşü]/g, ch => turkishMap[ch] || ch)
      .replace(/[^a-z0-9\-_]+/g, separator)
      .replace(sepPattern, separator)
      .replace(trimPattern, '')
      .slice(0, 30);
  }

  // Anket tipi slug'ı tire ile (general, beta-screen stiline uygun).
  normalizeSurveyMode(mode: string): string {
    return this.normalizeSlug(mode, '-');
  }

  // Puan alanı anahtarı alt çizgi ile (memnuniyet_puani stiline uygun).
  normalizeRatingKey(key: string): string {
    return this.normalizeSlug(key, '_');
  }

  async loadSurveySettings(): Promise<void> {
    this.surveySettingsLoading = true;
    try {
      const response = await this.$http.get('degerlendirme-ayarlari');
      const data = response.data || [];
      this.surveySettings = data.map((setting: SurveySetting) => this.normalizeSurveySetting(setting));
    } catch (error) {
      console.error('Anket ayarları yükleme hatası:', error);
      this.surveySettings = [];
      this.$store.commit('snackbar', 'Anket ayarları yüklenemedi.');
    } finally {
      this.surveySettingsLoading = false;
    }
  }

  normalizeSurveySetting(setting: SurveySetting): SurveySetting {
    const normalized = { ...setting };
    normalized.active = Number(normalized.active) ? 1 : 0;
    normalized.aylik_tekrar = Number(normalized.aylik_tekrar) ? 1 : 0;
    // Anahtar her zaman tanimli kalmali: undefined deger JSON kopyasinda kaybolur ve
    // dialogdaki v-model Vue 2'de reaktif olmaz.
    normalized.aylik_tekrar_metni = normalized.aylik_tekrar_metni || null;
    normalized.sort_order = Number(normalized.sort_order || 1);
    normalized.remind_later_text = normalized.remind_later_text || this.defaultRemindLaterText;
    normalized.submit_text = normalized.submit_text || this.defaultSubmitText;
    normalized.questions = Array.isArray(normalized.questions) ? normalized.questions.map(question => ({
      ...question,
      max_score: Number(question.max_score || 10),
      low_score_threshold: Number(question.low_score_threshold || 0),
      reason_required: Boolean(question.reason_required)
    })) : [];

    // extra_fields şeklini moda göre garanti et: beta-screen -> dizi, general -> nesne (LinkedIn alanı).
    // Aksi halde general anket düzenlenirken LinkedIn bölümü ilk açılışta görünmez.
    if (normalized.mode === 'beta-screen') {
      normalized.extra_fields = Array.isArray(normalized.extra_fields) ? normalized.extra_fields : [];
      // beta-screen'de LinkedIn ayrı `linkedin` nesnesinde tutulur; tüm anahtarlar seed edilir.
      normalized.linkedin = this.buildLinkedinFields(normalized.linkedin || {});
    } else {
      const current = normalized.extra_fields;
      const isPlainObject = !!current && !Array.isArray(current) && typeof current === 'object';
      const base = isPlainObject ? current : {};
      // general'da LinkedIn alanları extra_fields nesnesinde tutulur; bilinmeyen anahtarları
      // koruyarak LinkedIn anahtarlarını seed et (Vue 2 reaktivitesi için).
      normalized.extra_fields = { ...base, ...this.buildLinkedinFields(base) };
      normalized.linkedin = undefined;
    }

    return normalized;
  }

  async saveSurveySetting(setting: SurveySetting): Promise<void> {
    const key = this.getSettingKey(setting);
    this.savingSettingKey = key;
    try {
      // Kaydetmeden önce tipi garantiye al (combobox'ta Enter'sız blur senaryosu).
      setting.mode = this.normalizeSurveyMode(String(setting.mode || '')) || 'general';
      // Boş bırakılan puan alanları varsayılana düşer.
      setting.questions.forEach(question => {
        if (!question.key) question.key = 'memnuniyet_puani';
      });
      const payload: Record<string, any> = {
        mode: setting.mode,
        product_id: setting.product_id,
        title: setting.title,
        description: setting.description,
        remind_later_text: setting.remind_later_text,
        submit_text: setting.submit_text,
        active: setting.active,
        aylik_tekrar: setting.aylik_tekrar,
        // Bos metin backend'de NULL'a cevrilir -> varsayilan duyuru gosterilir.
        aylik_tekrar_metni: setting.aylik_tekrar_metni,
        sort_order: setting.sort_order,
        questions: setting.questions,
        extra_fields: setting.extra_fields
      };

      // beta-screen'de extra_fields dizi olduğundan LinkedIn alanlarını ayrı `linkedin` anahtarıyla gönder.
      if (setting.mode === 'beta-screen') {
        payload.linkedin = this.extractLinkedinFields(setting);
      }

      const response = await this.$http.request({
        method: setting.id ? 'PATCH' : 'POST',
        url: setting.id ? `degerlendirme-ayarlari/${setting.id}` : 'degerlendirme-ayarlari',
        data: { sendJson: true, data: payload }
      });

      const saved = this.normalizeSurveySetting(response.data || response);
      const index = setting.id
        ? this.surveySettings.findIndex(item => item.id === setting.id)
        : this.editingSurveySettingIndex;
      if (index >= 0) {
        this.$set(this.surveySettings, index, saved);
      } else {
        this.surveySettings.unshift(saved);
      }
      this.closeSurveySettingDialog();
      this.$store.commit('snackbar', 'Anket ayarları kaydedildi.');
    } catch (error) {
      console.error('Anket ayarları kaydetme hatası:', error);
      this.$store.commit('snackbar', 'Anket ayarları kaydedilemedi.');
    } finally {
      this.savingSettingKey = null;
    }
  }

  createSurveySetting(mode: SurveyMode): void {
    this.editingSurveySetting = this.createEmptySurveySetting(mode);
    this.editingSurveySettingIndex = -1;
    this.surveySettingDialog = true;
  }

  openSurveySettingDialog(setting: SurveySetting): void {
    this.editingSurveySetting = this.cloneSurveySetting(setting);
    this.editingSurveySettingIndex = this.surveySettings.findIndex(item => item === setting || item.id === setting.id);
    this.surveySettingDialog = true;
  }

  closeSurveySettingDialog(): void {
    this.surveySettingDialog = false;
    this.editingSurveySetting = null;
    this.editingSurveySettingIndex = -1;
  }

  cloneSurveySetting(setting: SurveySetting): SurveySetting {
    return JSON.parse(JSON.stringify(setting));
  }

  // Yazılan metni yerleşik + kayıtlı tip seçenekleriyle eşleştirir (düzenlenen anket hariç;
  // aksi halde v-model'deki ham metin kendi kendisiyle eşleşip slug'lamayı atlar).
  findSavedModeOption(raw: string): { text: string; value: string } | undefined {
    const lower = raw.toLocaleLowerCase('tr');
    const options = [
      ...this.baseSurveyModeOptions,
      ...this.surveySettings.map(setting => ({ text: this.getSurveyModeLabel(setting), value: setting.mode }))
    ];
    return options.find(option => option.value === raw || option.text.toLocaleLowerCase('tr') === lower);
  }

  onSurveyModeChange(setting: SurveySetting): void {
    // Combobox'tan seçimde slug (value) gelir; elle yazımda ham metin gelir.
    // Ham metin slug'a çevrilir, orijinal hali etiket olarak extra_fields.mode_label'da saklanır.
    const raw = String(setting.mode || '').trim();
    let newLabel: string | null = null;
    if (!raw) {
      // Kutu bilerek boşaltılmış olabilir; hemen 'general'a çevirme ki metin silinebilsin.
      // Boş bırakılıp kaydedilirse saveSurveySetting 'general'a düşürür.
      setting.mode = '';
    } else {
      const matched = this.findSavedModeOption(raw);
      if (matched) {
        setting.mode = matched.value;
      } else {
        const slug = this.normalizeSurveyMode(raw);
        setting.mode = slug || 'general';
        if (slug) newLabel = raw;
      }
    }
    // Ürün artık listeden seçiliyor; mod değişince ürünü otomatik atamıyoruz.
    // LinkedIn verisini iki şekil arasında taşı: general -> extra_fields (nesne), beta -> linkedin (nesne).
    const linkedin = this.extractLinkedinFields(setting);
    if (setting.mode === 'beta-screen') {
      setting.extra_fields = [];
      this.$set(setting, 'linkedin', linkedin);
    } else {
      // Mevcut nesne anahtarlarını (mode_label dahil) koruyarak LinkedIn alanlarını garanti et.
      const base = setting.extra_fields && !Array.isArray(setting.extra_fields)
        ? (setting.extra_fields as Record<string, any>)
        : {};
      const next: Record<string, any> = { ...base, ...linkedin };
      if (newLabel) next.mode_label = newLabel;
      this.$set(setting, 'extra_fields', next);
      this.$set(setting, 'linkedin', undefined);
    }
  }

  // Bir ayardaki LinkedIn alanlarını (hangi depoda olursa olsun) tek bir nesne olarak çıkarır.
  extractLinkedinFields(setting: SurveySetting): LinkedinFields {
    const source: any = Array.isArray(setting.extra_fields)
      ? (setting.linkedin || {})
      : (setting.extra_fields || {});
    return this.buildLinkedinFields(source);
  }

  // Tüm LinkedIn anahtarlarının var olduğu bir nesne döndürür. Vue 2'de v-model'in reaktif
  // çalışması için anahtarların önceden tanımlı olması gerekir (sonradan eklenen anahtar reaktif olmaz).
  buildLinkedinFields(source: any = {}): LinkedinFields {
    return {
      show_linkedin: source.show_linkedin ?? false,
      linkedin_title: source.linkedin_title ?? '',
      linkedin_url: source.linkedin_url ?? '',
      linkedin_label: source.linkedin_label ?? ''
    };
  }

  createEmptySurveySetting(mode: SurveyMode): SurveySetting {
    const productId = DEFAULT_PRODUCT_ID[mode] ?? DEFAULT_PRODUCT_ID.general;
    return {
      mode,
      product_id: productId,
      title: '',
      description: null,
      remind_later_text: this.defaultRemindLaterText,
      submit_text: this.defaultSubmitText,
      active: 0,
      aylik_tekrar: 0,
      aylik_tekrar_metni: null,
      sort_order: this.nextSortOrder(mode, productId),
      questions: [],
      // Yeni ankette LinkedIn alanları varsayılan değerlerle gelir; kullanıcı düzenleyebilir.
      extra_fields: mode === 'beta-screen' ? [] : this.buildLinkedinFields(DEFAULT_LINKEDIN),
      linkedin: mode === 'beta-screen' ? this.buildLinkedinFields(DEFAULT_LINKEDIN) : undefined
    };
  }

  addSurveyQuestion(setting: SurveySetting): void {
    setting.questions.push({
      key: 'memnuniyet_puani',
      title: '',
      helper_text: '',
      max_score: 10,
      low_score_threshold: 0,
      score_hint: '',
      reason_key: 'degerlendirme_sebebi',
      reason_required: false,
      reason_label: '',
      reason_placeholder: ''
    });
  }

  removeSurveyQuestion(setting: SurveySetting, index: number): void {
    setting.questions.splice(index, 1);
  }

  addExtraField(setting: SurveySetting): void {
    if (!Array.isArray(setting.extra_fields)) {
      setting.extra_fields = [];
    }

    setting.extra_fields.push({
      key: 'tavsiye_metni',
      type: 'textarea',
      label: '',
      optional_label: '',
      placeholder: '',
      required: false
    });
  }

  removeExtraField(setting: SurveySetting, index: number): void {
    if (Array.isArray(setting.extra_fields)) {
      setting.extra_fields.splice(index, 1);
    }
  }

  nextSortOrder(mode: SurveyMode, productId: number): number {
    const sameGroup = this.surveySettings.filter(setting => setting.mode === mode && Number(setting.product_id) === productId);
    if (!sameGroup.length) return 1;
    return Math.max(...sameGroup.map(setting => Number(setting.sort_order || 1))) + 1;
  }

  async deleteSurveySetting(setting: SurveySetting): Promise<void> {
    const approved = confirm('Anket silinecek. Onaylıyor musunuz?');
    if (!approved) return;

    const index = this.surveySettings.findIndex(item => item === setting || item.id === setting.id);
    if (!setting.id) {
      if (index >= 0) this.surveySettings.splice(index, 1);
      return;
    }

    try {
      await this.$http.delete(`degerlendirme-ayarlari/${setting.id}`);
      this.surveySettings.splice(index, 1);
      this.$store.commit('snackbar', 'Anket silindi.');
    } catch (error) {
      console.error('Anket silme hatası:', error);
      this.$store.commit('snackbar', 'Anket silinemedi.');
    }
  }

  async created() {
    await this.loadSurveySettings();
  }
}
